exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.photo-wrapper[data-v-8d7b77ca]{border:1px solid #000;border-radius:10px;border-style:dashed}div.time-entries[data-v-8d7b77ca]{height:100%}div.content[data-v-8d7b77ca]{padding-top:58px;padding-bottom:67px;background-color:#fff;min-height:100%}div.fixed-week-selector[data-v-8d7b77ca]{position:fixed;width:100%;z-index:1001;left:0;top:58px;background-color:#fff;border-bottom:2px solid #ffc72c}div.actions[data-v-8d7b77ca]{text-align:right}h4[data-v-8d7b77ca]{text-align:left;margin-bottom:0;text-transform:uppercase;font-weight:700}", ""]);

// exports
